export default __webpack_public_path__ + "static/media/screen2.03ada160.png";